// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lime-tint-lp-1":"#DDFA88","green-darkest":"#00482F","container":"PBUnLi"};